<header class="header">
    <div class="header__logo">
        <ng-container [ngTemplateOutlet]="logoTemplate"></ng-container>
    </div>

    <div class="header__inner">
        <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
    </div>
</header>
